import { addDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { printersCollectionRef } from '../firebase';
import {
  AuditActor,
  asFirestoreData,
  logActivity,
  stripSentinels,
} from '../audit-log';
import { diffFields } from '../diff-fields';
import type { Printer } from '../types';

const printerLabel = (p: { name: string }): string => p.name;

export const createPrinter = async (
  actor: AuditActor | null,
  payload: Record<string, unknown>,
): Promise<string> => {
  const docRef = await addDoc(printersCollectionRef, payload);
  const snapshot = stripSentinels(payload);
  logActivity({
    actor,
    entity: 'printer',
    entityRef: docRef.id,
    entityLabel: printerLabel(snapshot as { name: string }),
    action: 'create',
    snapshot,
  });
  return docRef.id;
};

export const updatePrinter = async (
  actor: AuditActor | null,
  before: Printer,
  payload: Record<string, unknown>,
): Promise<void> => {
  await updateDoc(
    doc(printersCollectionRef, before.ref),
    asFirestoreData(payload),
  );
  const changes = diffFields(before, payload);
  if (Object.keys(changes).length === 0) return;
  logActivity({
    actor,
    entity: 'printer',
    entityRef: before.ref,
    entityLabel: printerLabel(before),
    action: 'update',
    changes,
  });
};

export const deletePrinter = async (
  actor: AuditActor | null,
  before: Printer,
): Promise<void> => {
  await deleteDoc(doc(printersCollectionRef, before.ref));
  const { ref, ...rest } = before;
  logActivity({
    actor,
    entity: 'printer',
    entityRef: before.ref,
    entityLabel: printerLabel(before),
    action: 'delete',
    snapshot: rest as unknown as Record<string, unknown>,
  });
};
